import { platformFeatures } from '@/mocks/homeData';

export default function PlatformFeatures() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="text-foreground-400 text-xs font-medium tracking-wider uppercase">
            WHY CHOOSE US
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mt-3">
            为什么选择我们
          </h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-xl mx-auto">
            我们致力于为每一位韩漫爱好者打造最优质的阅读平台
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {platformFeatures.map((feature, index) => (
            <div
              key={feature.id}
              className={`rounded-2xl overflow-hidden ${index === 1 && feature.bgStyle.includes('bg-cover') ? 'relative' : feature.bgStyle}`}
            >
              {feature.bgImage ? (
                <>
                  <img
                    src={feature.bgImage}
                    alt={feature.title}
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-black/40"></div>
                  <div className="relative z-10 p-8 flex flex-col justify-between min-h-[280px]">
                    <div>
                      <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm mb-4">
                        <i className={`${feature.icon} text-white text-lg`}></i>
                      </span>
                      <h3 className="text-xl font-heading font-semibold text-white mb-3">{feature.title}</h3>
                      <p className="text-white/70 text-sm leading-relaxed">{feature.description}</p>
                    </div>
                  </div>
                </>
              ) : (
                <div className="p-8 flex flex-col min-h-[280px]">
                  <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm mb-4">
                    <i className={`${feature.icon} text-background-50 text-lg`}></i>
                  </span>
                  <h3 className="text-xl font-heading font-semibold text-background-50 mb-3">{feature.title}</h3>
                  <p className="text-background-50/70 text-sm leading-relaxed">{feature.description}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}